__turbopack_context__.v({
  "lc-dropdown-menu": "DropdownMenu-module__6KX5Va__lc-dropdown-menu",
});
